import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { GameIntroScene } from './scenes/GameIntro';

interface PhaserVendingMachineProps {
    onComplete: () => void;
}

interface PhaserVendingMachineState {
}

const gameConfig: GameConfig = {
    title: "Vending Machine Game",
    version: "0.2",
    backgroundColor: "#000000",
};

class PhaserVendingMachine extends React.Component<PhaserVendingMachineProps, PhaserVendingMachineState> {
    private game: Phaser.Game;
    constructor(props: PhaserVendingMachineProps) {
        super(props);
        bindAllOfThis(this, PhaserVendingMachine.prototype);
    }

    render() {
        return (<div>
            <PhaserGameComponent scenes={GameIntroScene} config={gameConfig} onComplete={this.props.onComplete} />
        </div>);
    }
}

export default PhaserVendingMachine;



// WEBPACK FOOTER //
// ./src/games/VendingMachine/Main.tsx